module.exports = __webpack_public_path__ + "img/Services.4e55b210.svg";